class Configurator extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll(".button-row__button input");
    const variantSelectors = this.querySelectorAll(".configurator-variant");
    const sectionScroller = this.querySelector(".button-row__fade");
    const buttonRow = this.querySelector(".button-row");
    const detailsContainer = this.querySelector(".configurator-details");
    console.log("Configurator loaded");
    const handleVisibility = () => {
      variantSelectors.forEach((selector) => {
        selector.classList.add("hidden");
      });
    };
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const variantSelector = this.querySelector(`.${mutation.target.id}`);
        handleVisibility();
        variantSelector.classList.remove("hidden");
        if (variantSelector.closest("configurator-extra") != null) {
          variantSelectors.forEach((selector) => {
            if (selector.closest("configurator-extra") != null) {
              selector.classList.remove("hidden");
            }
          });
        }
      });
    });
    if (buttonRow && detailsContainer) {
      if (window.innerWidth <= 1e3) {
        window.addEventListener("scroll", () => {
          const buttonRowBottom = buttonRow.getBoundingClientRect().bottom;
          const detailsContainerBottom = detailsContainer.getBoundingClientRect().bottom;
          if (buttonRowBottom >= detailsContainerBottom) {
            buttonRow.style.opacity = 0;
          }
          if (buttonRowBottom <= detailsContainerBottom) {
            buttonRow.style.opacity = 1;
          }
        });
      }
    }
    if (sectionScroller) {
      let startX;
      let scrollLeft;
      var isDown = false;
      sectionScroller.addEventListener("mousedown", (e) => {
        isDown = true;
        startX = e.pageX - sectionScroller.offsetLeft;
        scrollLeft = sectionScroller.scrollLeft;
      });
      sectionScroller.addEventListener("mouseup", () => {
        isDown = false;
      });
      sectionScroller.addEventListener("mouseleave", () => {
        isDown = false;
      });
      sectionScroller.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - sectionScroller.offsetLeft;
        const walk = x - startX;
        sectionScroller.scrollLeft = scrollLeft - walk;
      });
    }
    if (buttons) {
      buttons.forEach((button) => {
        button.addEventListener("change", (e) => {
          const variantSelector = this.querySelector(`.${e.target.id}`);
          handleVisibility();
          variantSelector.classList.remove("hidden");
          console.log("ss");
          if (variantSelector.closest("configurator-extra") != null) {
            variantSelectors.forEach((selector) => {
              if (selector.closest("configurator-extra") != null) {
                selector.classList.remove("hidden");
              }
            });
          }
          if (button.closest(".button-row__button.hidden") != null) {
            document.querySelector(".layer-5").checked = true;
            document.querySelector(".layer-5").classList.add("active");
            document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
          }
          if (window.height_scroll != void 0) {
            window.height_scroll();
          }
        });
        observer.observe(button, {
          attributes: true
        });
      });
      window.history.pushState("configurator base", "", window.location.href);
      const view_all_check = JSON.parse(sessionStorage.getItem("configuratorConfig")) != null ? JSON.parse(sessionStorage.getItem("configuratorConfig")).every((item) => item === null) : false;
      if (JSON.parse(sessionStorage.getItem("configuratorConfig")) == null || view_all_check) {
        document.querySelectorAll(".view_summary").forEach((view_summary) => {
          view_summary.style.display = "none";
        });
      } else {
        document.querySelectorAll(".view_summary").forEach((view_summary) => {
          view_summary.style.display = "block";
        });
      }
    }
  }
}
if (customElements.get("configurator-main") === void 0) {
  customElements.define("configurator-main", Configurator);
}
